<template>
  <!-- 详情页 -->
  <div class="tbusinDetail">
    <div class="tdBox">
      <div class="tdbLeft">
        <div class="tbl1">
          <div class="t1Img">
            <img
              src="https://bce.bdstatic.com/aiqicha-land/img/cbs.d57c79ec.png"
              alt=""
              class="t1iImg"
            />
          </div>
          <div class="t1Texts">
            <div class="tt1">
              <p class="t11">工商注册服务</p>
              <p class="t12">迈出创业第一步，专业顾问为您提供工商注册服务</p>
            </div>
            <div class="tt2">
              <p class="t21">价格：9.9元/年</p>
              <div class="t22">
                <dl>
                  <dt v-for="item in 3" :key="item">
                    <img
                      src="data:image/png;base64,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"
                      alt=""
                      class="dtIcon"
                    />
                    <p class="dtp">极速办理，快速下照</p>
                  </dt>
                </dl>
              </div>
            </div>
            <div class="tt3">
              <p class="t31">服务地区：</p>
              <div class="t32">
                <select>
                  <option value="1">北京</option>
                  <option value="2">上海</option>
                </select>
              </div>
            </div>
            <div class="tt4">
              <ul class="t4Ul">
                <li class="t4Li" v-for="item in 3" :key="item">
                  <p class="t41">公司性质：</p>
                  <div class="t42">
                    <div class="t42b" v-for="item in 3" :key="item">
                      有限公司
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="tt5">
              <p class="t51">服务内容：</p>
              <div class="t52">
                <p class="t52p">工商执照办理</p>
                <p class="t52p">刻章服务</p>
              </div>
            </div>
            <div class="tt6">
              <p class="t61">备注：</p>
              <div class="t62">须备注商业注册地址</div>
            </div>
            <div class="tt7">
              <div class="t7b" v-for="item in 3" :key="item">立即想要</div>
            </div>
          </div>
        </div>
        <div class="tbl2">
          <div class="t2Tab">
            <ul>
              <li class="t2tLi" v-for="item in 5" :key="item">
                服务介绍{{ item }}
              </li>
            </ul>
          </div>
          <div class="t2Box">
            <div class="t21">
              <div class="t21Top">
                <p class="tt1">服务介绍</p>
                <p class="tt2">
                  三种套餐类型按需自由选择，助力初创企业快速起步
                </p>
              </div>
              <div class="t21List">
                <dl>
                  <dt class="t2Dt" v-for="item in 6" :key="item">
                    <div class="t2dBox">
                      <div class="tdb1">
                        <p class="t1p">工商执照办理</p>
                      </div>
                      <p class="tdb2">
                        工商营业执照办理，是公司注册最基本的交付物
                      </p>
                      <div class="tdb3">
                        <div class="t3Bs" v-for="item in 3" :key="item">
                          普通注册
                        </div>
                      </div>
                    </div>
                  </dt>
                </dl>
              </div>
            </div>
            <div class="t22">
              <div class="t22Top">服务优势</div>
              <div class="t22List">
                <dl>
                  <dt class="t22Dt" v-for="item in 4" :key="item">
                    <img
                      src="https://bce.bdstatic.com/aiqicha-land/img/advantage1.8af41d11.png"
                      alt=""
                      class="t2dImg"
                    />
                    <div class="t2dText">
                      <p class="tdt1">官方自营品牌保障</p>
                      <p class="tdt2">威有自营品牌保障安全贴心</p>
                      <p class="tdt2">保密协议保护企业信息安全</p>
                    </div>
                  </dt>
                </dl>
              </div>
            </div>
            <div class="t33">
              <div class="t3Top">
                <p class="t3t1">服务流程</p>
                <p class="t3t2">
                  业务办理流程及时间，因当地工商局政策不同存在差异，具体时间和流程请以实际为准，详情请咨询当地服务商
                </p>
              </div>
              <div class="t3Img">
                <img
                  src="https://bce.bdstatic.com/aiqicha-land/img/process.3517a2ed.png"
                  alt=""
                  class="t3iImg"
                />
              </div>
            </div>
            <div class="t44">
              <div class="t4Top">办理材料</div>
              <div class="t4TeImg">
                <div class="t4Texts">
                  <ul>
                    <li class="t4tLi" v-for="item in 5" :key="item">
                      <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABGZJREFUWAnNmc+LHEUUx7+vemY2RpTswawRFS+iRBQh4ClHDwmSi5LDenPdBDXuwYhgDpI9eAxEUAkm6D8QvAkht9zEQxA0ivEgwQSTxcAGFtbdnekqv9+e9NC786OrZ2Znt2C2u6vee/XpV9Wvqt4ahixHF8LU7f+wzwF71z0aroG6AXWZC0DTb6A55bDhgdVnHsGDK1/a+jBd0WZ8OXQy1H0DT6yvY9oH7InXBJxhbWoKy24D/16/aM1Y3SjA48dD8stjmEkamPEt0GnDF1eDTzew9MoKli5ftrTMUingy++Hae/xbJqiVmasSnuSoOUc/v71gi0P0usLGEKwF9/FAXM4MMjAqG3B4+4f3+KumXHqdpeegIuLwX2/hOeaTUx3q4y/pl7H8lszuLW4aPymNpeu+STPTRJOOHKE+lTfm/H4cW2t0LBOynPFvtWn+i7W6X4ToD6I7Z5zWwGKz+pbDMW6DqBCib7WYuNO3ItBLHnfHUDFuXGHkryTKlcxiCXXyQC1QigI55U7fRWLmMSRAbYc9o+6QlR8qWPO4wf+PuylJxYtqR3AZop9vQS3o44emXU+nOWW4knaP9KvD633anPalVRd+PsZLatPPN6BDx9ncmbeDF/30xGT2GraMvUTGmc9F7IPAsKcbHJZazEkn+VO4eqgPsRWo8v3DhIaR5tLcRoW3pYtgzVDwBlvuFZmW2w1bTYZILelcCNgNcOZYOHNdge2lho+IeWPMR2KraadcGjFiFeToYdcwmHk+vqGNOm5VQ7pR7y5HmtJbHxBAsZqRMop2HL//zm/1NfbKrZCsAX+bkSayMTE5lCy+WasOqWYRY1jUcYTNAh3rgD3gF/rexzaSnBZX2RzjNcliDiqmKXYxak6Owgy1LDHtfAF5Q+35ew+vXaScDcH6fVrE5vT6aufgOqzWMWYlckwhmWxrIcCw8ijSRNfIYTX2s12j8AnOBf/6iEeVSU2p6PhIGm+/RV64TPFLskxlp1STCvq8Gt9nPPlAuFeVT0/iDs8xc2z/nZRruq92Di9sFqmSJmrjF2fKoZJ1kKYo0+zFYEenube6BvCHWzbsVt8i/mW4V6Z3bJ2sTkdqssE1e4drtGbp4m3pmdDmCWkThGX6NfnVcfaP3l0n08T3G8/j/ZXbNkZ4OCJ8FL0euxxiB47z6HevAKZ3eB8WyDSymhYbW0d9H+/ZL9la4hO/NFGHQOtaQ4ytj0sAfYz0mxedurytmGvOVMGqHSETvyxxhTTFNsIyelhP8lzvlY+l2Pti0VMks+GWDcvzIWnqh6YuAI9zTdc4nVgqJL9KkWH+Zvf2T/SyTyoG+VKlI7QfWzh290ZN5wYxJIzdACVyFGuJG/YqasYikmlzhDnQMMMda476rU4tLmtjgfzCiVylCvJnyd1VZ/qe2t/XYDKMimRM0nIPHnUK8PVNcT5GyiRs2vTbzmkrrs2gVmE3NUp4CKo0hHKQuigH712PzSwrUn0ImR+P6l/Q/wPTuy0fWtBbDAAAAAASUVORK5CYII="
                        alt=""
                        class="t4lIcon"
                      />
                      <div class="t4lP">
                        <p class="tp1">核名</p>
                        <p class="tp2">2-5个名称字号</p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="t4Img">
                  <img
                    src="https://bce.bdstatic.com/aiqicha-land/img/material.43f79e07.png"
                    alt=""
                    class="t4iImg"
                  />
                </div>
              </div>
            </div>
            <div class="t55">
              <div class="t5Top">常见问题</div>
              <div class="t5List">
                <ul>
                  <li class="t5Li" v-for="item in 5" :key="item">
                    <img
                      src="https://bce.bdstatic.com/aiqicha-land/img/Q1.e0e8e26c.png"
                      alt=""
                      class="t5lImg"
                    />
                    <div class="t5lT">
                      <p class="t5t1">下单咨询后，我怎么享受服务？</p>
                      <p class="t5t2">
                        咨询下单成功后，将会有专业服务人员与您联系，进行一对一服务。
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tdbRight">
        <div class="tr1">
          <div class="t1T">
            <p class="tt1">云企业顾问</p>
            <p class="tt2">为您一对一解决问题</p>
          </div>
          <div class="t1B">提交需求</div>
        </div>
        <div class="tr2">
          <div class="t2Top">
            <p class="t2t">关联服务</p>
          </div>
          <ul>
            <li class="t2Li" v-for="item in 3" :key="item">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAB0CAMAAABjROYVAAABL1BMVEUAAAD///+BrP+Aqv/k///R4P/R4P+Aqv/Q4P+Bq//Q4P/z8/PR4f/V4f8kavSFrf/z8/Py8vIkafTz8/PR4P8lafTz8/MlavQ0dfUlavQkavTz8/MkavMka/QkavUla/QkbfUqa/MrgP/Q3/8kafPy8vL///+Aqv/d3d36+//p8P9ilfzm7v3m5ubf399ik/YobPRYjfcvcfUlavS5z/5qm/1+p/pFgPhrmfY4d/Y/e/UrbvU6d/QzcvNEfvLF2P+Erf9+qf96pv+Rtv52o/5wn/6dvfxfkvhMhfczdPSCqPPc5PKyyv1mmPyJrvtdkvvs7vK5zPLL2/+rxv3R3PPC0vOyx/OhvPNznvNSh/Pi5/LX4PLK2PKbuPJ4ofI/eu9gj+yVsOaftuTN09/X2d4vzJZJAAAAI3RSTlMAAWW9Bv3z89XIlJKPK+0Z/fPW1b1mK/vw3r69r4Z/RTErBr/4GzkAAAKaSURBVGje7dZnU9tAEIBh2djGNUAgpFetdbj3igsEVzrpvf//35DDTEYJkSxp707G+N7PmnlGa/lulT/FosGAylAgGI0pzvKF/Spz/rDPkbmhcmnDiRpWORW2b8b8vFC//d81qnIrahsN8kODttEAPzRgG1U5JlGJSlSiEpXowqPJhGZQIqnafyJu0tp6ZNMQTWomJe0/ETdvNeIzQBOaSQn7T8Sndd/nOkqLuD5e2uqmyA/J+lVV9uyi67NA19xHaRKVqESvGJrJZjNuo5ktWsZlNHuOZl1GtyZJlP0Sx6Ds6woCZV/M5gtlGe98fUgL9D+V6DyhF1fbIlzik3VlMRYziUr0mqP4SxxzOLCvK4hjkP9iph/413UbPH2zn2sWx61O/fMnl7bBw3ob9Drff4m/xLv1Evxb+4dodFCE//v2Uyh6nAejvh4IRKtgUvOjMHRQArM6p4LQchHM+yIILcC0zoSgL2Fq74WgBZjeawFot2SB1gWge2BRWwA6BKte8UdHluj+AXe0AdZ1qMsT7V46dXPpdM6Azb/7wAktV0djuFRa09JgVOuMB1ougEEaDYx7y45W8+AQhVuM6IshgGP09hM2tAAIFG4+01E+t3Yurf1VOmc8YDx6aHTeXpi6aviqHjw6BCQKj9FouQTI8cJDNHoMNMSHRLuHRgt49AYabc0Cbc8CzYOerQNf7y7v8epXm3kPKOnx7u0QxzUB3SNFWVkimEZ49KniwZmkjzbveBQvQdbAoimvEsKiFaTZJCFlmWCrocztHllmQJ9jBpyvEIqGCF4dO39PatLxegmD6nTCjR6hefW/DKqTogOyeLJLaEse/XDAtZuqbdsbbC1FyXNzRdGPQXz9ylFqekf9Hpm0M/DS9/wNGeCOyRT3QCMAAAAASUVORK5CYII="
                alt=""
                class="t2lImg"
              />
              <div class="t2lT">
                <p class="tlt1">云上公司注册</p>
                <p class="tlt2">支持异地远程注册，送注册地址，享园区政策扶持</p>
                <p class="tlt3">威有1起</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TbusinDetail",
};
</script>

<style lang="less" scoped>
// 详情页
.tbusinDetail {
  width: 1423px;
  min-height: 3400px;
  margin: 0 auto;
  margin-top: 87px;
  // overflow: hidden;
  .tdBox {
    width: 85%;
    height: 100%;
    margin: 0 auto;
    // margin-top: 50px;
    .tdbLeft {
      width: 80%;
      height: 100%;
      float: left;
      .tbl1 {
        width: 100%;
        height: 630px;
        border-radius: 20px;
        background-color: white;
        box-shadow: 1px 1px 10px 1px gainsboro;
        .t1Img {
          width: 345px;
          height: 275px;
          float: left;
          .t1iImg {
            width: 95%;
            height: 95%;
            margin-top: 2%;
            margin-left: 2%;
            border-radius: 20px;
          }
        }
        .t1Texts {
          width: 600px;
          height: 95%;
          margin-left: 10px;
          float: left;
          .tt1 {
            width: 95%;
            height: 60px;
            margin-top: 20px;
            .t11 {
              width: 100%;
              height: 30px;
              line-height: 30px;
              font-size: 24px;
            }
            .t12 {
              width: 100%;
              height: 20px;
              line-height: 20px;
              font-size: 14px;
              color: gray;
              margin-top: 10px;
            }
          }
          .tt2 {
            width: 95%;
            height: 115px;
            margin-top: 10px;
            overflow: hidden;
            background: url("https://bce.bdstatic.com/aiqicha-land/img/buy_bac.5808e05e.png");
            .t21 {
              width: 100%;
              height: 28px;
              line-height: 28px;
              font-size: 22px;
              color: #ef2323;
              margin-top: 20px;
            }
            .t22 {
              width: 100%;
              height: 20px;
              line-height: 20px;
              margin-top: 20px;
              dl {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-around;
                dt {
                  min-width: 133px;
                  height: 20px;
                  .dtIcon {
                    width: 20px;
                    height: 20px;
                    float: left;
                  }
                  .dtp {
                    min-width: 108px;
                    height: 20px;
                    float: left;
                    margin-left: 5px;
                    color: #2468f2;
                  }
                }
              }
            }
          }
          .tt3 {
            width: 95%;
            height: 30px;
            margin-top: 10px;
            .t31 {
              width: 90px;
              height: 30px;
              line-height: 30px;
              font-size: 14px;
              float: left;
            }
            .t32 {
              width: 220px;
              height: 30px;
              float: left;
              margin-left: 10px;
              select {
                width: 100%;
                height: 100%;
              }
            }
          }
          .tt4 {
            width: 95%;
            height: 150px;
            margin-top: 20px;
            .t4Ul {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              .t4Li {
                width: 100%;
                height: 30px;
                .t41 {
                  width: 90px;
                  height: 30px;
                  line-height: 30px;
                  font-size: 14px;
                  float: left;
                }
                .t42 {
                  width: 400px;
                  height: 30px;
                  margin-left: 10px;
                  float: left;
                  .t42b {
                    width: 90px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    border: 1px solid #2468f2;
                    color: #2468f2;
                    float: left;
                    border-radius: 5px;
                  }
                  .t42b:nth-child(n + 2) {
                    margin-left: 10px;
                  }
                }
              }
            }
          }
          .tt5 {
            width: 95%;
            height: 30px;
            margin-top: 20px;
            .t51 {
              width: 90px;
              height: 30px;
              line-height: 30px;
              font-size: 14px;
              float: left;
            }
            .t52 {
              width: 400px;
              height: 30px;
              line-height: 30px;
              margin-left: 5px;
              float: left;
              .t52p {
                min-width: 56px;
                height: 30px;
                color: #2468f2;
                float: left;
              }
              .t52p:nth-child(2) {
                margin-left: 30px;
              }
            }
          }
          .tt6 {
            width: 95%;
            height: 30px;
            margin-top: 20px;
            .t61 {
              width: 90px;
              height: 30px;
              line-height: 30px;
              font-size: 14px;
              float: left;
            }
            .t62 {
              width: 400px;
              height: 30px;
              line-height: 30px;
              color: gray;
              font-size: 14px;
            }
          }
          .tt7 {
            width: 95%;
            height: 40px;
            line-height: 40px;
            margin-top: 50px;
            .t7b {
              width: 150px;
              height: 40px;
              background-color: #2468f2;
              color: white;
              border-radius: 5px;
              text-align: center;
              float: left;
            }
            .t7b:nth-child(n + 2) {
              margin-left: 20px;
              background-color: white;
              border: 1px solid #2468f2;
              color: #2468f2;
            }
          }
        }
      }
      .tbl2 {
        width: 100%;
        height: 2600px;
        border-radius: 20px;
        background-color: white;
        box-shadow: 1px 1px 10px 1px gainsboro;
        margin-top: 50px;
        .t2Tab {
          width: 100%;
          height: 46px;
          position: sticky;
          top: 87px;
          z-index: 6;
          background-color: white;
          ul {
            width: 70%;
            height: 100%;
            display: flex;
            justify-content: space-around;
            .t2tLi {
              width: 116px;
              height: 46px;
              text-align: center;
              line-height: 46px;
              font-size: 14px;
              cursor: pointer;
            }
            .t2tLi:hover {
              border-bottom: 4px solid #2468f2;
            }
          }
        }
        .t2Box {
          width: 90%;
          margin: 0 auto;
          .t21 {
            width: 100%;
            height: 630px;
            overflow: hidden;
            .t21Top {
              width: 50%;
              height: 60px;
              margin: 0 auto;
              margin-top: 20px;
              .tt1 {
                width: 100%;
                height: 30px;
                text-align: center;
                line-height: 30px;
                font-size: 28px;
              }
              .tt2 {
                width: 100%;
                height: 20px;
                line-height: 20px;
                text-align: center;
                font-size: 16px;
                color: gray;
                margin-top: 10px;
              }
            }

            .t21List {
              width: 100%;
              height: 490px;
              margin-top: 20px;
              dl {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-around;
                flex-wrap: wrap;
                .t2Dt {
                  width: 260px;
                  height: 224px;
                  box-shadow: 1px 1px 10px 1px gainsboro;
                  background-color: white;
                  border-radius: 5px;
                  .t2dBox {
                    width: 90%;
                    height: 90%;
                    margin: 0 auto;
                    margin-top: 5%;
                    .tdb1 {
                      width: 100%;
                      height: 42px;
                      border-bottom: 1px solid gray;
                      .t1p {
                        font-size: 19px;
                        color: #2468f2;
                      }
                    }
                    .tdb2 {
                      width: 100%;
                      height: 80px;
                      margin-top: 20px;
                      color: gray;
                      font-size: 14px;
                    }
                    .tdb3 {
                      width: 100%;
                      height: 24px;
                      margin-top: 20px;
                      .t3Bs {
                        width: 62px;
                        height: 24px;
                        line-height: 24px;
                        text-align: center;
                        color: #2468f2;
                        background-color: rgba(56, 96, 244, 0.06);
                        border-radius: 5px;
                        float: left;
                        font-size: 12px;
                      }
                      .t3Bs:nth-child(n + 2) {
                        margin-left: 10px;
                      }
                    }
                  }
                }
              }
            }
          }
          .t22 {
            width: 100%;
            height: 447px;
            overflow: hidden;
            .t22Top {
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 28px;
              margin-top: 20px;
            }
            .t22List {
              width: 100%;
              height: 360px;
              margin-top: 20px;
              dl {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-around;
                flex-wrap: wrap;
                .t22Dt {
                  width: 50%;
                  height: 138px;
                  .t2dImg {
                    width: 126px;
                    height: 100%;
                    float: left;
                  }
                  .t2dText {
                    width: 210px;
                    height: 100%;
                    float: left;
                    margin-left: 20px;
                    .tdt1 {
                      width: 100%;
                      height: 25px;
                      line-height: 25px;
                      font-size: 19px;
                      color: #2468f2;
                    }
                    .tdt2 {
                      width: 100%;
                      height: 19px;
                      line-height: 19px;
                      font-size: 14px;
                      color: gray;
                      margin-top: 20px;
                    }
                  }
                }
              }
            }
          }
          .t33 {
            width: 100%;
            height: 550px;
            overflow: hidden;
            .t3Top {
              width: 100%;
              height: 70px;
              margin-top: 20px;
              text-align: center;
              .t3t1 {
                width: 100%;
                height: 40px;
                line-height: 40px;
                font-size: 28px;
              }
              .t3t2 {
                width: 100%;
                height: 20px;
                line-height: 20px;
                font-size: 16px;
                margin-top: 10px;
              }
            }
            .t3Img {
              width: 100%;
              height: 370px;
              margin-top: 20px;
              .t3iImg {
                width: 90%;
                height: 100%;
                display: block;
                margin: 0 auto;
              }
            }
          }
          .t44 {
            width: 100%;
            height: 440px;
            overflow: hidden;
            .t4Top {
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 28px;
            }
            .t4TeImg {
              width: 100%;
              height: 350px;
              margin-top: 20px;
              .t4Texts {
                width: 50%;
                height: 100%;
                float: left;
                ul {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-around;
                  .t4tLi {
                    width: 90%;
                    height: 55px;
                    margin-left: 10%;
                    .t4lIcon {
                      width: 20px;
                      height: 20px;
                      float: left;
                      margin-top: 5px;
                    }
                    .t4lP {
                      min-width: 290px;
                      height: 100%;
                      float: left;
                      margin-left: 15px;
                      .tp1 {
                        width: 100%;
                        height: 25px;
                        line-height: 25px;
                        font-size: 20px;
                      }
                      .tp2 {
                        width: 100%;
                        height: 20px;
                        line-height: 20px;
                        font-size: 14px;
                        margin-top: 10px;
                        color: gray;
                      }
                    }
                  }
                }
              }
              .t4Img {
                width: 50%;
                height: 100%;
                float: left;
                .t4iImg {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }
          .t55 {
            width: 100%;
            height: 520px;
            overflow: hidden;
            .t5Top {
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 28px;
            }
            .t5List {
              width: 100%;
              height: 432px;
              margin-top: 10px;
              ul {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                .t5Li {
                  width: 100%;
                  height: 55px;
                  .t5lImg {
                    width: 44px;
                    height: 38px;
                    float: left;
                    margin-top: 5px;
                  }
                  .t5lT {
                    width: 750px;
                    height: 55px;
                    float: left;
                    margin-left: 15px;
                    .t5t1 {
                      width: 100%;
                      height: 25px;
                      line-height: 25px;
                      font-size: 20px;
                    }
                    .t5t2 {
                      width: 100%;
                      height: 20px;
                      line-height: 20px;
                      color: gray;
                      font-size: 14px;
                      margin-top: 10px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .tdbRight {
      width: 19%;
      height: 100%;
      float: right;
      .tr1 {
        width: 100%;
        height: 110px;
        overflow: hidden;
        background: url("https://bce.bdstatic.com/aiqicha-land/img/requirement_bac.c7d85856.png")
          no-repeat center;
        border-radius: 5px;
        .t1T {
          width: 130px;
          height: 55px;
          color: white;
          margin-top: 20px;
          margin-left: 5px;
          float: left;
          .tt1 {
            width: 100%;
            height: 25px;
            line-height: 25px;
            font-size: 18px;
          }
          .tt2 {
            width: 100%;
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            margin-top: 10px;
          }
        }
        .t1B {
          width: 70px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          border-radius: 20px;
          color: #2468f2;
          font-size: 12px;
          background-color: white;
          margin-left: 20px;
          margin-top: 40px;
          float: left;
        }
      }
      .tr2 {
        width: 100%;
        height: 410px;
        margin-top: 10px;
        overflow: hidden;
        box-shadow: 1px 1px 10px 1px gainsboro;
        border-radius: 5px;
        .t2Top {
          width: 100%;
          height: 25px;
          line-height: 25px;
          text-align: center;
          .t2t {
            font-size: 18px;
            margin-top: 10px;
          }
        }
        ul {
          width: 95%;
          height: 350px;
          margin: 0 auto;
          margin-top: 15px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .t2Li {
            width: 100%;
            height: 94px;
            .t2lImg {
              width: 60px;
              height: 60px;
              float: left;
            }
            .t2lT {
              width: 150px;
              height: 100%;
              float: left;
              .tlt1 {
                width: 100%;
                height: 22px;
                line-height: 22px;
                font-size: 16px;
              }
              .tlt2 {
                width: 100%;
                height: 40px;
                font-size: 13px;
                color: gray;
                margin-top: 5px;
              }
              .tlt3 {
                width: 100%;
                height: 20px;
                color: #ef2323;
                font-size: 14px;
                margin-top: 5px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
